import { FinancesDataType } from '~/models/Boss';

export const TableHeaders = [
  {
    key: 'comercial-plan',
    values: ['Plano', 'Quantidade', 'Total'],
    dataKey: FinancesDataType.SUBSCRIPTIONS_BY_PLAN_NAME,
  },
  {
    key: 'payment-form',
    values: ['Forma', 'Quantidade', 'Total'],
    dataKey: FinancesDataType.SUBSCRIPTIONS_BY_PAYMENT_METHOD,
  },
  {
    key: 'status',
    values: ['Status', 'Quantidade', 'Total'],
    dataKey: FinancesDataType.SUBSCRIPTIONS_BY_STATUS,
  },
  {
    key: 'finance',
    values: ['Mês', 'Quantidade de vendas', 'Total'],
    dataKey: FinancesDataType.PAYMENTS_BY_MONTH_AND_YEAR,
  },
];
